import React from 'react';
import {AppBar, Button, Toolbar, Typography} from '@material-ui/core';
import './NavBar.css';

function NavBar() {
    return(
        <AppBar className="appbar" position="static">
            <Toolbar className="toolbar">
                <Typography>PANDEMIC</Typography>
                <Button className="toolbar_btn" color="inherit" href="/Home">Home</Button>
                <Button color="inherit" href="/AboutMe">About Me</Button>
            </Toolbar>
        </AppBar>
    )
}
export default NavBar;